<h2 mat-dialog-title>{{name}}</h2>
<mat-dialog-content>

  <div style="min-height: 50px">
    @if (selection.selected.length > 0) {
      <button matButton="filled" class="warning-button" (click)="bulkDelete()">Delete Selected</button>
      <!--        <button matButton="outlined">Clear Selection</button>-->
    }
  </div>

  <div class="draggable-table-container">
    <mat-table #table
               [dataSource]="dataSource" >
      <!-- Position Column -->
<!--      <ng-container matColumnDef="position" >-->
<!--        <mat-header-cell *matHeaderCellDef class="w-10p"></mat-header-cell>-->
<!--        <mat-cell *matCellDef="let element">-->
<!--          <mat-icon class="example-drag-cursor">drag_indicator</mat-icon>-->
<!--        </mat-cell>-->
<!--      </ng-container>-->

      <ng-container matColumnDef="id">
        <mat-header-cell *matHeaderCellDef > </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(element.id) : null"
            [checked]="selection.isSelected(element.id)"
          ></mat-checkbox>

        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.title}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="download">
        <mat-header-cell *matHeaderCellDef> Downloads </mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.user_downloads || '0'}}</mat-cell>
      </ng-container>
      <ng-container matColumnDef="duration">
        <mat-header-cell *matHeaderCellDef> Duration </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.duration  | secondsToTime }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="date">
        <mat-header-cell *matHeaderCellDef> Date </mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.createdAt | date:'MM/dd/yyyy' }}</mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
  </div>

</mat-dialog-content>
<mat-dialog-actions>
  <button matButton (click)="onNoClick()">Cancel</button>
<!--  <button matButton>Save</button>-->
</mat-dialog-actions>
